import { Controller } from 'react-hook-form';
import CustomCalendar from '../CustomCalendar/CustomCalendar';

const CustomControlledCalendar = ({ control, name, calendarType, rules, defaultValue, ...rest }) => {
  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      defaultValue={defaultValue}
      render={({ field: { value, onChange } }) => {
        switch (calendarType) {
          case 'RangePicker':
            return (
              <CustomCalendar
                {...rest}
                calendarType="RangePicker"
                range={value || { startDate: '', endDate: '' }}
                setRange={onChange}          // range object -> field value
              />
            );

          case 'SelectableDate':
            return (
              <CustomCalendar
                {...rest}
                calendarType="SelectableDate"
                selectedDate={value || undefined}
                setCurrDate={null}           // suppress the display-string callback
                onChange={onChange}          // needs the 1-line hook below
              />
            );

          case 'Multidot':
            return (
              <CustomCalendar
                {...rest}
                calendarType="Multidot"
                selectedDate={typeof value === 'string' ? value : undefined}
                setSelectedData={onChange}   // clicked dots array -> field value
              />
            );

          default:
            return null;
        }
      }}
    />
  );
}

export default CustomControlledCalendar;